var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.address)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.address.replace(/, D[ea]nmark/, '').replace(/,/g, '<br>'))}}):_c('McSpinner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }